import { Notification } from '@core/models/notification/notification';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { addNotification, removeAll, removeNotificationSuccess } from '../actions/notifications.actions';

export type NotificationsState = Notification[];

const initialState: NotificationsState = [];

export const notificationsReducer = createReducer(
  initialState,
  on(addNotification, (state, action) => ([...state, action.payload])),
  on(removeNotificationSuccess, (state, action) => ({ ...state, payload: state.filter((notification) => notification.target !== action.payload.target) })),
  on(removeAll, () => initialState)
);

export const selectNotificationsState = createFeatureSelector<NotificationsState>('notificationsState');


